<label class="label">{{ label }}</label>
<span class="content"><ng-content></ng-content></span>
